export default "__VITE_ASSET__CkAl17BY__"